import { classNames } from "@opensea/ui-kit"

export const LISTINGS_FLOW_ITEMS_TABLE_CLASSNAMES = {
  item: classNames("w-[120px] grow first:pl-0 md:w-[200px] min-w-0"),
  floor: classNames("hidden w-[120px] justify-end md:flex"),
  topOffer: classNames("hidden w-[120px] justify-end md:flex"),
  cost: classNames("hidden w-[120px] justify-end md:flex"),
  proceeds: classNames("hidden w-[120px] justify-end md:flex"),
  price: classNames("w-[150px] justify-end gap-2 last:pr-0"),
  remove: classNames("w-[28px]"),
  traitFloor: classNames("hidden w-[120px] justify-end md:flex"),
} as const
